<template>
  <div class="container-fluid">
    <b-row class="col-md-8 col-lg-8">
<!--      <b-col lg="3" md="4" sm="4"><b-button class="autopsy-button" @click="onGetExportSubmission" style="width: 100%;"><i class="fas fa-print"></i> พิมพ์</b-button></b-col>-->
      <b-col lg="3" md="4" sm="4"><b-button class="autopsy-button" v-b-modal.print style="width: 100%;text-align: center" ><b-icon-printer-fill></b-icon-printer-fill> พิมพ์</b-button></b-col>
<!--      <b-col lg="3" md="4" sm="4"><b-button class="email-button" v-b-modal.sendEmil style="color: #2DA1A9;width: 100%;text-align: center" ><i class="fas fa-envelope"></i>  ส่งอีเมล</b-button></b-col>-->
      <b-col lg="3" md="4" sm="4"><b-button class="email-button" v-b-modal.sendEmil style="color: #2DA1A9;width: 100%;text-align: center" > ส่งอีเมล</b-button></b-col>
    </b-row>
    <b-modal
        id="print"
        style="width: 100%"
        ref="modal-print"
        title="ต้องการรูปภาพประกอบด้วยหรือไม่"
        @hidden="resetModal"
    >
      <b-form ref="modal-print" @submit.stop.prevent="onGetExportSubmission(true)">
      <input type="checkbox" size="sm" id="pictureReportPrint" v-model="checkPicture" >&nbsp
      <label for="pictureReportPrint" class="radio-label"><b style="color: #17a2b8">แสดงรูปภาพประกอบ</b>
      </label>
      </b-form>
      <template v-slot:modal-footer="{ ok, cancel,hidden}">
        <b-button size="sm" variant="outline-danger" @click="cancel()">
          cancel
        </b-button>
        <b-button size="sm" variant="outline-success" @click="onGetExportSubmission(true)">
          Ok
        </b-button>

      </template>
    </b-modal>
    <b-modal
      id="sendEmil"
      style="width: 100%"
      ref="modal"
      title="รายชื่อที่ต้องการส่งE-mail"
      @hidden="resetModal"
      >
    <form ref="form" @submit.stop.prevent="handleOk(true)" >
      <input type="checkbox" id="officer_email" v-b-visible="checkOfficerVal" :disabled="!dataCaseform.officer_email" :value="dataCaseform.officer_email" v-model="checkedEmail" @change="addName(true,val=dataCaseform.officer_name)">&nbsp
      <label for="officer_email"><b>พนักงานสอบสวน</b>
        <div v-if="dataCaseform.officer_email != null && dataCaseform.officer_email !==''" >
          <p class="radio-label"><b style="color: #034694;padding-left: 5px">&nbsp{{dataCaseform.officer_name}}</b><br>  <b style="color: #17a2b8;padding-left: 5px">&nbsp{{dataCaseform.officer_email}}</b></p>
        </div>
      <div v-if="!dataCaseform.officer_email">
<!--        <p class="radio-label">{{msgOfficer}}</p>-->
        <p style="color: #ff253a">{{msgOfficer}}</p>
      </div>
      </label>

      <br>

      <input type="checkbox" id="doctor_email"v-b-visible="checkDoctorVal" :disabled="!dataCaseform.doctor_email" :value="dataCaseform.doctor_email" v-model="checkedEmail" @change="addName(true,val=dataCaseform.sign_doctor_name)">&nbsp
      <label for="doctor_email" ><b>แพทย์ผู้ชันสูตรพลิกศพ</b>
        <div v-if="dataCaseform.doctor_email  != null && dataCaseform.doctor_email !== '' "  v-model="checkedName">
          <p class="radio-label"><b style="color: #034694;padding-left: 5px">&nbsp{{dataCaseform.sign_doctor_name}}</b> <br> <b style="color: #17a2b8;padding-left: 5px">&nbsp{{dataCaseform.doctor_email}}</b></p>
        </div>
        <div v-if="!dataCaseform.doctor_email">
<!--          <p class="radio-label">{{msgDoctor}}</p>-->
          <p style="color: #ff253a">{{msgDoctor}}</p>
        </div>
      </label>

      <br>

      <input type="checkbox" id="represent_email"v-b-visible="checkRepresentVal" :disabled="!dataCaseform.represent_email" :value="dataCaseform.represent_email" v-model="checkedEmail" @change="addName(true,val=dataCaseform.represent_name)">&nbsp
      <label for="represent_email" ><b>เจ้าหน้าที่ที่ได้รับมอบหมายแทน</b>
        <div v-if="dataCaseform.represent_email  != null && dataCaseform.represent_email != '' "  v-model="checkedName">
          <p class="radio-label"><b style="color: #034694;padding-left: 5px">&nbsp{{dataCaseform.represent_name}}</b> <br> <b style="color: #17a2b8;padding-left: 5px">&nbsp{{dataCaseform.represent_email}}</b></p>
        </div>
        <div v-if="!dataCaseform.represent_email">
<!--          <p class="radio-label">{{msgRepresent}}</p>-->
          <p style="color: #ff253a">{{msgRepresent}}</p>
        </div>
      </label>

      <br>

      <input type="checkbox" id="attorney_email" v-b-visible="checkAttorneyVal" :disabled="!dataCaseform.attorney_email" :value="dataCaseform.attorney_email" v-model="checkedEmail" @change="addName(true,val=dataCaseform.attorney_name)" >&nbsp
      <label for="attorney_email" ><b>พนักงานอัยการ</b>
        <div v-if="dataCaseform.attorney_email  != null && dataCaseform.attorney_email != '' "  v-model="checkedName">
          <p class="radio-label"><b style="color: #034694;padding-left: 5px">&nbsp{{dataCaseform.attorney_name}}</b> <br> <b style="color: #17a2b8;padding-left: 5px">&nbsp{{dataCaseform.attorney_email}}</b></p>
        </div>
        <div v-if="!dataCaseform.attorney_email">
<!--          <p class="radio-label">{{msgAttorney}}</p>-->
          <p style="color: #ff253a">{{msgAttorney}}</p>
        </div>
      </label>

      <br>

      <input type="checkbox" id="admin_email" v-b-visible="checkAdminVal" :disabled="!dataCaseform.admin_email" :value="dataCaseform.admin_email" v-model="checkedEmail" @change="addName(true,val=dataCaseform.admin_name)" >&nbsp
      <label for="admin_email" ><b>พนักงานฝ่ายปกครอง</b>
        <div v-if="dataCaseform.admin_email  != null && dataCaseform.admin_email != '' " :value="dataCaseform.admin_name" v-model="checkedName">
          <p class="radio-label"><b style="color: #034694;padding-left: 5px">&nbsp{{dataCaseform.admin_name}}</b> <br> <b style="color: #17a2b8;padding-left: 5px">&nbsp{{dataCaseform.admin_email}}</b></p>
        </div>
        <div v-if="!dataCaseform.admin_email">
<!--          <p class="radio-label">{{msgAdmin}}</p>-->
          <p style="color: #ff253a">{{msgAdmin}}</p>
        </div>
      </label>
      <br>
    </form>
    <template v-slot:modal-footer="{ ok, cancel,hidden}">

            <input type="checkbox" size="sm" id="pictureReport" v-model="checkPicture" >&nbsp
            <label for="pictureReport" class="radio-label"><b style="color: #17a2b8">แสดงรูปภาพประกอบ</b>
            </label>
      <b-button size="sm" variant="outline-danger" @click="cancel()">
        ยกเลิก
      </b-button>
      <b-button size="sm" variant="outline-success" :disabled="checkedEmail.length<=0" @click="handleOk(true)">
        ส่ง
      </b-button>

    </template>

  </b-modal>
  </div>
</template>

<script>
    import {mapState} from "vuex";
    import swal from 'sweetalert2/dist/sweetalert2.min.css'
    import Footer from "@/components/Footer";
    export default {
        name: "QuestionStatus",
      components: {Footer},
      computed: {
        ...mapState({
          dataCaseform: state => {
            return state.Eventform.form;
          },
        }),
        checkOfficerVal : async function (){
          await this.dataCaseform;
           if (!this.dataCaseform.officer_email && this.dataCaseform.officer_email == null || this.dataCaseform.officer_email ==='' ){
              return (this.checkOfficer = true , this.msgOfficer = "ยังไม่ได้ระบุ");
          } else {
             return (this.checkOfficer = false , this.msgOfficer = '');
           }
        },
        checkDoctorVal : async function (){
          await this.dataCaseform;
          if (!this.dataCaseform.doctor_email&&this.dataCaseform.doctor_email == null || this.dataCaseform.doctor_email ==='' ){
            return (this.checkDoctor = true , this.msgDoctor  = "ยังไม่ได้ระบุ");
          } else {
            return (this.checkDoctor = false , this.msgDoctor = '');
          }

        },
        checkRepresentVal :async  function (){
          await this.dataCaseform;
          if (!this.dataCaseform.represent_email && this.dataCaseform.represent_email == null || this.dataCaseform.represent_email ==='' ){
            return (this.checkRepresent = true , this.msgRepresent = "ยังไม่ได้ระบุ");
          }else {
            return (this.checkRepresent = false , this.msgRepresent = '');
          }
        },
        checkAttorneyVal :async  function (){
          await this.dataCaseform;
          if (!this.dataCaseform.attorney_email){
            return (this.checkAttorney = true , this.msgAttorney = "ยังไม่ได้ระบุ" );
          }else {
            return (this.checkAttorney = false , this.msgAttorney = '');
          }
        },
        checkAdminVal:async function (){
          await this.dataCaseform;
          if (!this.dataCaseform.admin_email){
            return (this.checkAdmin=true, this.msgAdmin = "ยังไม่ได้ระบุ" );
          }else {
            return (this.checkAdmin = false , this.msgAdmin = '');
          }
        },
      },
        data() {
            return {
                status: 'ยังไม่บันทึก',
                case_date: new Date().toJSON().slice(0,10).replace(/-/g,'/'),
                checkOfficer:false,
                checkDoctor:false,
                checkRepresent:false,
                checkAttorney:false,
                checkAdmin:false,
                checkedEmail:[],
                checkedName:[],
                msgOfficer:'',
                msgDoctor:'',
                msgRepresent:'',
                msgAttorney:'',
                msgAdmin:'',
                checkPicture:false,

            }
        },
        methods: {
          onGetExportSubmission(print){
            let data ={
              id : this.dataCaseform.id,
              picture: this.checkPicture
            }
            if (print === true && print || print != null){
              this.$store.dispatch("Eventform/onGetExportSubmission",data);
              this.$ga.event("Export/SubmissionPDF","Eventform/onGetExportSubmission","SubmissionPDF")
              this.resetModal()
              this.hideModal('modal-print')
            }else {
              this.resetModal();
              this.hideModal('modal-print')
            }
          },
          handleOk(send){
            let listEmail = this.checkedEmail
            let listName = this.checkedName
            let picture = this.checkPicture
            if (send === true && listEmail != null && listEmail != '' ){
              this.sendEmail(listEmail,listName,picture);
              this.resetModal()
              this.hideModal('modal')
            }else {
              this.resetModal()
              this.hideModal('modal')
            }
          },
          resetModal(){
            this.checkedEmail = []
            this.checkedName = []
            this.checkPicture=false;
          },
          async sendEmail(listEmail,listName,picture){
            let data ={
              id:this.dataCaseform.id,
              email:listEmail,
              name:listName,
              picture:picture
            }
            // alert("email: "+data.email+", name: "+data.name+"picture: "+data.picture)
            const Toast = this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
            });
            Toast.fire({
              icon: 'info',
              title: 'กำลังดำเนินการ'
            })
           await this.$store.dispatch("Eventform/onSendEmail", data).then(res=>{
             if (res && res == 200){
               Toast.close();
               this.showProgressiveFill('ส่งอีเมลสำเร็จ')
             }
            })
          },
          addName(con,val){
            if (con == true){
              this.checkedName.push(val)
              return  this.checkedName;
            }else {
              this.resetModal();
            }

          },
          showProgressiveFill(message) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: 'success',
              title: message
            })
          },
          hideModal(modalName) {
            this.$refs[modalName].hide()
          },
          // showErrorFill(message) {
          //   const Toast = this.$swal.mixin({
          //     toast: true,
          //     position: 'top-end',
          //     showConfirmButton: false,
          //     timer: 3000,
          //     timerProgressBar: true,
          //   });
          //   Toast.fire({
          //     icon: 'error',
          //     title: message
          //   })
          // },
        },
    }
</script>

<style scoped>
    .quest-input{
        color: white;
        background: #878787;
        border-radius: 30px;
        text-align: center;
        /*margin: 0 1em;*/
    }
    input[type=checkbox] {
      transform: scale(1.5);
    }

</style>
